'use strict';

var Carousel = require('./lib/carousel');

module.exports = Carousel;



//////////////////
// WEBPACK FOOTER
// ./~/nuka-carousel/index.js
// module id = 644
// module chunks = 213534597649335